// extracted by mini-css-extract-plugin
export var ad = "main-module--ad--67320";
export var main = "main-module--main--6e704";
export var main__black = "main-module--main__black--930d6";
export var main__bloodorange = "main-module--main__bloodorange--61ecb";
export var main__chartruse = "main-module--main__chartruse--42141";
export var main__cobalt = "main-module--main__cobalt--c1763";
export var main__custom = "main-module--main__custom--6c18b";
export var main__emerald = "main-module--main__emerald--3f800";
export var main__fullscreen = "main-module--main__fullscreen--a65a0";
export var main__paper = "main-module--main__paper--25a11";
export var main__pink = "main-module--main__pink--fe98a";
export var main__regular = "main-module--main__regular--0e3d0";
export var main__sky = "main-module--main__sky--ea1fb";
export var main__white = "main-module--main__white--da2c6";
export var spin = "main-module--spin--5d196";